import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CurrentUserService } from '@shared/services';
import { notifyAccessDenied } from './notify-access-denied';

/**
 * Prevents a Country Admin from entering features outside Country Information.
 * Elevated admins remain allowed if they also happen to carry Country Admin.
 */
export const countryAdminRestrictedGuard: CanActivateFn = () => {
  const router = inject(Router);
  const currentUser = inject(CurrentUserService);

  if (!currentUser.isRestrictedCountryAdmin()) {
    return true;
  }

  notifyAccessDenied();
  return router.createUrlTree([currentUser.defaultAuthenticatedRoute()]);
};
